<template>
    <div id="dashboard" style="width:256px;height:200px;"></div>
</template>
<script>
import echarts from 'echarts'
export default {
    name:'dashboardProgress',
    data(){
        return{}
    },
    props:['rate'],
    watch:{
        rate:function(newVal,oldVal){
            this.initEcharts();
        }
    },
    methods:{
        initEcharts(){
            var myEcharts = echarts.init(document.getElementById('dashboard'))
            var option = {
                polar:{ //极坐标系
                    center:['50%','50%'],
                    radius:180,
                },
                radiusAxis:{ //极坐标系径向轴
                    show:false,
                    type: 'category',
                },
                angleAxis:{ //极坐标系角度轴
                    show:false,
                    max:100/270*360,
                    type:'value',
                    startAngle:225,
                    splitLine:{
                        show:false,
                    }
                },
                barMaxWidth:12,
                series: [
                    {
                        // 上层圆环，显示数据
                        type:'bar',
                        data:[{
                            value:this.rate,
                            itemStyle:{
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 1, //从左到右 0-1
                                    y2: 0,
                                    colorStops: [{
                                        offset: 0,
                                        color: '#4735F8'
                                    }, {
                                        offset: 1,
                                        color: '#54FDF1'
                                    }],
                                }
                            }
                        }],
                        roundCap:true,
                        coordinateSystem:'polar',
                        z:2,
                        barGap:'-100%',
                    },
                    { //下层圆环显示最大值，即圆环背景
                        type: 'bar',
                        data: [{
                            value: 100,
                            itemStyle: {
                                color: '#12175A'
                            }
                        }],
                        barGap: '-100%',
                        coordinateSystem: 'polar',
                        roundCap: true,
                        z: 1
                    },
                    // 仪表盘，存放数据
                    {
                        name: '溢价率',
                        type: 'gauge',
                        startAngle:225,
                        endAngle:-45,
                        detail: {
                            show:true,
                            formatter:'{value}%',
                            color:'#B8D7FF',
                            fontSize:'38',
                            offsetCenter:[0,'-20%']
                        },
                        title:{
                            offsetCenter:[0,'30%'],
                            textStyle:{
                                color:'#B8D7FF',
                                fontSize:'22',  
                            }
                        },
                        data: [{value: this.rate, name: '溢价率'}],
                        legendHoverLink:false,
                        splitLine:{
                            show:false,//不显示分隔样式线
                        },
                        axisTick:{
                            show:false,//不显示刻度线
                        },
                        axisLabel:{
                            show:false,//刻度标签
                        },
                        pointer:{
                            show:false,//仪表盘指针
                        },
                        axisLine: { //仪表盘轴线样式
                            show: false,
                            
                        }
                        
                    }
                ]
            };
            myEcharts.setOption(option)

        }
    },
    mounted(){
        // this.initEcharts()
    }
}
</script>

<style lang="scss" scoped>

</style>

